import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import IconMessage, { IconMessageIcon } from './IconMessage';

interface EmptyResultProps {
  title: string;
  subtitle: string;
}

const EmptyResultMobile = ({
  title,
  subtitle,
}: EmptyResultProps) => {
  const { t } = useTranslation();
  return (

    <Box
   sx={{
    minHeight: '100dvh',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'background.paper',
    pt: '15px',
    boxSizing: 'border-box',
  }}
    >
      <IconMessage
        icon={IconMessageIcon.SEARCH_WARNING}
        title={title}
        subtitle={subtitle}
      />
    </Box>
  );
};

export default EmptyResultMobile;
